import { proxy, subscribe } from 'valtio';

type InboxState = {
  selectedTaskId: string | undefined;
  missedCallsExternal: number;
  missedCallsInternal: number;
};

function getInitialState(): InboxState {
  const stored = localStorage.getItem('inbox');

  if (stored) {
    return JSON.parse(stored);
  }

  return {
    selectedTaskId: undefined,
    missedCallsExternal: 0,
    missedCallsInternal: 0,
  };
}

export const inboxState = proxy<InboxState>(getInitialState());

subscribe(inboxState, () => {
  localStorage.setItem('inbox', JSON.stringify(inboxState));
});
